module.exports = __webpack_public_path__ + "img/diaohua5.dd1f1157.jpg";